export default "__VITE_ASSET__hed9KXz___"